<template>
    <b-modal
        id="newPaymentMethodModal"
        ref="newPaymentMethodModal"
        :lazy="true"
        :no-close-on-backdrop="true"
        title-tag="h2"
        title-html="<img src='assets/icons/lock.png' class='pr-1' />New Payment
                Method"
    >
        <form class="form-horizontal pl-2">
            <b-form-group
                v-if="data.cc_processor !== 'GRAVITY'"
                :label-for="`name_on_card`"
                label="Name on Card:"
                label-cols="3"
            >
                <b-form-input
                    id="name_on_card"
                    v-model="payment_data.name_on_card"
                    v-validate="'required'"
                    :class="{ 'border-danger': errors.has('name_on_card') }"
                    name="name_on_card"
                    autofocus
                    :placeholder="
                        data.cc_processor === 'STRIPE'
                            ? 'Name on Card (required)'
                            : ''
                    "
                ></b-form-input>
            </b-form-group>
            <b-form-group v-if="data.cc_processor === 'CCONNECT'">
                <div v-show="cc_iframe_load" class="iframe_label_p">
                    <label id="card_number">Card Number:</label>
                    <label id="expiration">Expiration:</label>
                    <label id="scode">Security Code</label>
                    <a id="tip" href="#" @click.prevent>
                        <i
                            v-b-popover.hover.bottom="
                                'For Visa, MasterCard, and Discover, the security code is the last 3 digit number located on the back of the card or above the signature line. For American Express, it is the 4 digits on the front of the card above the end of the card number.'
                            "
                            class="cus-information"
                            container="app"
                            title="Note"
                        ></i> </a
                    >:
                </div>
                <div
                    v-show="cc_iframe_load"
                    id="iframe_content"
                    class="iframe_content"
                >
                    <iframe
                        id="tokenframe_p"
                        name="tokenframe"
                        :src="payment_data.cardconnect_iframe_url"
                        frameborder="0"
                        scrolling="no"
                        @load="$emit('iframe-loaded')"
                    ></iframe>
                </div>
            </b-form-group>
            <b-form-group
                v-if="data.cc_processor == 'STRIPE'"
                :label-for="`card_number`"
                label="Card Number:"
                label-cols="3"
            >
                <b-form-input
                    id="card_number"
                    v-model="payment_data.card_number"
                    v-validate="{
                        required: true,
                        regex: /(?:\d[ -]?){12,18}\d/
                    }"
                    :class="{
                        'border-danger':
                            errors.has('card_number') ||
                            stripe_data.validation.card_number
                    }"
                    name="card_number"
                    placeholder="Card Number (required)"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                v-if="data.cc_processor == 'STRIPE'"
                :label-for="`expiry_month`"
                label="Expiration:"
                label-cols="3"
            >
                <div class="row no-gutters">
                    <b-form-select
                        id="expiry_month"
                        v-model="payment_data.expiry_month"
                        v-validate="'required'"
                        :class="{
                            'border-danger':
                                errors.has('expiry_month') ||
                                stripe_data.validation.expiry_month_year
                        }"
                        :options="_cc_months"
                        name="expiry_month"
                        class="form-control col-7 mr-1"
                        placeholder="Month (required)"
                    ></b-form-select>
                    <b-form-select
                        id="expiry_year"
                        v-model="payment_data.expiry_year"
                        v-validate="'required'"
                        :class="{
                            'border-danger':
                                errors.has('expiry_year') ||
                                stripe_data.validation.expiry_month_year
                        }"
                        :options="_cc_years"
                        name="expiry_year"
                        class="form-control col-5 firefox-col-5"
                        placeholder="Year (required)"
                    ></b-form-select>
                </div>
            </b-form-group>
            <b-form-group
                v-if="data.cc_processor === 'STRIPE'"
                :label-for="`security_code`"
                label="Security Code:"
                label-cols="3"
            >
                <b-form-input
                    id="security_code"
                    v-model="payment_data.security_code"
                    v-validate="'required'"
                    :class="{
                        'border-danger':
                            errors.has('security_code') ||
                            stripe_data.validation.security_code
                    }"
                    name="security_code"
                    placeholder="Security code (required)"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                v-if="data.cc_processor === 'GRAVITY'"
                style="margin-bottom: -0.525rem;"
            >
                <div v-show="data.giframe_load" class="giframe_labelp">
                    <label id="gcard_number">Card Number:</label>
                    <label id="gexpiration">Expiration:</label>
                    <label id="gscode">Security Code</label>
                </div>
                <div v-show="data.giframe_load" class="giframe_contentp">
                    <div id="cardNumberContainer" style="height: 35px;"></div>
                    <div
                        id="expirationDateContainer"
                        style="height: 35px;"
                    ></div>
                    <div
                        id="securityCodeContainer"
                        style="height: 35px; float: left;"
                    ></div>
                    <div v-show="data.giframe_load" style="margin-top: 5px;">
                        <a id="gtip" href="#" class="ml-1" @click.prevent>
                            <i
                                v-b-popover.hover.bottom="
                                    'For Visa, MasterCard, and Discover, the security code is the last 3 digit number located on the back of the card or above the signature line. For American Express, it is the 4 digits on the front of the card above the end of the card number.'
                                "
                                class="cus-information"
                                container="app"
                                title="Note"
                            ></i>
                        </a>
                    </div>
                </div>
            </b-form-group>
            <b-form-group
                :label-for="`is_primary`"
                label="Primary:"
                label-cols="3"
            >
                <b-form-select
                    id="is_primary"
                    v-model="payment_data.is_primary"
                    v-validate="'required'"
                    :disabled="payment_data.existing_pmp == 0"
                    :class="{ 'border-danger': errors.has('is_primary') }"
                    name="is_primary"
                >
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </b-form-select>
            </b-form-group>
        </form>
        <div slot="modal-footer" class="w-100">
            <b-button
                v-if="!loading"
                class="float-left"
                variant="secondary"
                @click="$refs.newPaymentMethodModal.hide()"
                >Cancel</b-button
            >
            <div class="float-right">
                <img v-if="loading" src="assets/ajax-loader.gif" />
                <span v-else>
                    <b-button
                        v-if="
                            data.cc_processor == 'CCONNECT' &&
                            data.entity == 'client'
                        "
                        variant="primary"
                        @click="saveCConnect"
                        >Save</b-button
                    >
                    <b-button
                        v-else-if="data.cc_processor == 'STRIPE'"
                        variant="primary"
                        @click="saveStripe"
                        >Save</b-button
                    >
                    <b-button
                        v-else-if="data.cc_processor == 'GRAVITY'"
                        variant="primary"
                        id="save-btn"
                        >Save</b-button
                    >
                    <b-button
                        v-else-if="data.entity == 'business'"
                        variant="primary"
                        @click="saveCConnect(1)"
                        >Save</b-button
                    >
                </span>
            </div>
        </div>
    </b-modal>
</template>
<style></style>

<script>
import PaymentDialogHelper from "@/module/payment/helper.js";

export default {
    components: {},
    mixins: [PaymentDialogHelper],
    data() {
        return {
            resources: {},
            data: {
                name: "",
                client: null,
                is_extension: null,
                cc_processor: "CCONNECT",
                is_first_time: false,
                entity: "client",
                isWellnessPlan: "hide",
                giframe_load: ""
            },
            stripe_data: {
                stripeToken: null,
                validation: {}
            },
            payment_data: {
                id: null,
                name_on_card: null,
                card_number: null,
                expiry_month: "",
                expiry_year: "",
                security_code: null,
                is_primary: "1",
                existing_pmp: 0,
                direct: -1,
                cardconnect_iframe_url: "",
                mytoken: "",
                myexpiry: "",
                myerror: ""
            },
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            year_options: [],
            loading: false,
            cc_iframe_load: false
        };
    },
    watch: {
        "payment_data.cardconnect_iframe_url"(value) {
            if (value.includes("cardconnect.com")) {
                this.$once("iframe-loaded", () => {
                    setTimeout(() => {
                        this.loading = false;
                        this.cc_iframe_load = true;
                        let self = this;

                        window.addEventListener(
                            "message",
                            function (event) {
                                self.payment_data.myerror = "";

                                let token = JSON.parse(event.data);
                                self.payment_data.mytoken = token.message;

                                if (
                                    self.payment_data.mytoken !== "" &&
                                    typeof token.expiry !== "undefined"
                                ) {
                                    self.payment_data.myexpiry = token.expiry;
                                } else {
                                    if (
                                        typeof token.validationError !==
                                        "undefined"
                                    ) {
                                        self.payment_data.myerror =
                                            token.validationError;
                                    }
                                }
                            },
                            false
                        );
                    }, 350);
                });
            } else {
                this.cc_iframe_load = false;
            }
        }
    },
    methods: {
        open(data) {
            this.datePickerOptions.format = this.getDateFormat();
            this.data = _.merge(this.data, data);
            this.payment_data.name_on_card = _.get(data, "client.label");
            this.$refs.newPaymentMethodModal.show();
            this.getPaymentMethodProfile();

            if (!this.data.is_first_time) {
                this.payment_data.is_primary = "0";
            }

            if (data.cc_processor === "CCONNECT") {
                this.loading = true;
            } else if (data.cc_processor === "GRAVITY") {
                var width = "100%";
                var mq = window.matchMedia("(max-width: 400px)");

                if (mq.matches) {
                    width = "50%";
                }

                this.callGravityIFrame(width);
            }
        },
        saveStripe() {
            let params = {
                credit_card_card_number: this.payment_data.card_number,
                credit_card_ccv: this.payment_data.security_code,
                credit_card_expiry_month: this.payment_data.expiry_month,
                credit_card_expiry_year: this.payment_data.expiry_year
            };
            this._saveStripe(params).then(response => {
                if (response.id) {
                    this.stripe_data.stripeToken = response.id;
                }
                return this.save();
            });
        },
        saveCConnect(is_business) {
            this.loading = true;
            setTimeout(() => {
                if (
                    this.payment_data.mytoken !== "" &&
                    this.payment_data.expiry !== ""
                ) {
                    if (is_business === 1) {
                        return this.saveBusiness();
                    } else {
                        return this.save();
                    }
                } else {
                    let err = this.payment_data.myerror;

                    if (err !== "") {
                        if (err === "Invalid Account Number") {
                            this._message("Invalid card number", "danger");
                        }

                        if (err === "Invalid CVV") {
                            this._message("Invalid security code", "danger");
                        }

                        if (err === "Invalid Expiry")
                            this._message("Invalid expiration date", "danger");
                    }
                }

                this.loading = false;
            }, 4000);
        },
        save() {
            let self = this;
            self.loading = true;
            self.$validator.validateAll().then(result => {
                if (result) {
                    let post = {
                        id: self.payment_data.id,
                        direct: self.payment_data.direct,
                        existing_pmp: self.payment_data.existing_pmp,
                        is_extension: self.data.is_extension,
                        entity_id: _.get(
                            self,
                            "data.client.id",
                            self.$root.setting.business_id
                        ),
                        entity_type: self.data.entity,
                        cc_processor: self.data.cc_processor,
                        name_on_card: self.payment_data.name_on_card,
                        card_number: self.payment_data.card_number,
                        expiry_month: self.payment_data.expiry_month,
                        expiry_year: self.payment_data.expiry_year,
                        security_code: self.payment_data.security_code,
                        is_primary: self.payment_data.is_primary,
                        mytoken: self.payment_data.mytoken,
                        myexpiry: self.payment_data.myexpiry
                    };

                    if (self.data.cc_processor === "STRIPE") {
                        post.stripeToken = this.stripe_data.stripeToken;
                    }

                    if (self.data.cc_processor === "GRAVITY") {
                        post.gravity = {
                            uniqueTransId: self.data.uniqueTransId,
                            accountCardType: self.data.accountCardType,
                            accountExpiryDate: self.data.accountExpiryDate,
                            last4digit: self.data.last4digit,
                            externalTransactionId:
                                self.data.externalTransactionId
                        };
                    }

                    return $.post(
                        process.env.APPS + "common/payment_method_profile/save",
                        post,
                        "json"
                    )
                        .then(function (response) {
                            if (response.return === 200) {
                                self.$emit("saved", response);
                                self._message(response.message, "success");

                                self.loading = false;
                                self.$refs.newPaymentMethodModal.hide();
                            } else {
                                self.loading = false;
                                self._message(response.message, "danger");
                            }
                        })
                        .always(() => {
                            self.loading = false;
                        });
                } else {
                    self.loading = false;
                }
            });
        },
        saveBusiness() {
            let self = this;
            self.loading = true;
            self.$validator.validateAll().then(result => {
                if (result) {
                    let post = {
                        direct: self.payment_data.direct,
                        existing_pmp: self.payment_data.existing_pmp,
                        is_extension: self.data.is_extension,
                        entity_type: self.data.entity,
                        cc_processor: self.data.cc_processor,
                        name_on_card: self.payment_data.name_on_card,
                        card_number: self.payment_data.card_number,
                        expiry_month: self.payment_data.expiry_month,
                        expiry_year: self.payment_data.expiry_year,
                        security_code: self.payment_data.security_code,
                        is_primary: self.payment_data.is_primary,
                        mytoken: self.payment_data.mytoken,
                        myexpiry: self.payment_data.myexpiry
                    };

                    return $.post(
                        process.env.APPS +
                            "business/payment_method_profile/save",
                        post,
                        "json"
                    )
                        .then(function (response) {
                            if (response.return == 200) {
                                self.$emit("saved", response);
                                self._message(response.message, "success");

                                self.loading = false;
                                self.$refs.newPaymentMethodModal.hide();
                            } else {
                                self.loading = false;
                                self._message(response.message, "danger");
                            }
                        })
                        .always(() => {
                            self.loading = false;
                        });
                } else {
                    self.loading = false;
                }
            });
        },
        getPaymentMethodProfile() {
            let self = this;
            this.$http
                .get(
                    process.env.PAYMENT_SERVICE +
                        "payment-method?entity_id=" +
                        _.get(
                            this,
                            "data.client.id",
                            this.$root.setting.business_id
                        ) +
                        "&entityType=" +
                        this.data.entity
                )
                .then(response => {
                    if (response.data.response.resources.data.length > 0) {
                        this.payment_data.existing_pmp = 1;
                        this.payment_data.is_primary = "0";
                    }

                    this.payment_data.cardconnect_iframe_url =
                        response.data.response.cconnect_iframe_url;
                });
        },
        callGravityIFrame(width) {
            let self = this;
            self.loading = true;

            self.getToken().then(function (transactionToken) {
                var hosted = emergepayFormFields.init({
                    transactionToken: transactionToken,
                    transactionType: "CreditSaveCard",
                    fieldSetUp: {
                        cardNumber: {
                            appendToSelector: "cardNumberContainer",
                            useField: true,
                            styles: {
                                padding: "6px",
                                border: "1px solid #cccccc",
                                "font-family":
                                    "Verdana, Helvetica, Arial, sans-serif",
                                "font-size": "12px",
                                width: width
                            }
                        },
                        cardExpirationDate: {
                            appendToSelector: "expirationDateContainer",
                            useField: true,
                            styles: {
                                padding: "6px",
                                border: "1px solid #cccccc",
                                "font-family":
                                    "Verdana, Helvetica, Arial, sans-serif",
                                "font-size": "12px",
                                width: width
                            }
                        },
                        cardSecurityCode: {
                            appendToSelector: "securityCodeContainer",
                            useField: true,
                            styles: {
                                padding: "6px",
                                border: "1px solid #cccccc",
                                "font-family":
                                    "Verdana, Helvetica, Arial, sans-serif",
                                "font-size": "12px",
                                width: width
                            }
                        },
                        totalAmount: {
                            appendToSelector: "amountContainer",
                            useField: false,
                            styles: {}
                        },
                        externalTranId: {
                            useField: false,
                            styles: {}
                        }
                    },
                    fieldErrorStyles: {
                        "border-color": "#b94a48",
                        "background-color": "#ffdddd"
                    },
                    onFieldError: function (data) {
                        self.loading = false;

                        setTimeout(() => {
                            $("#save-btn").on("click", function (event) {
                                self.loading = true;
                                event.preventDefault();
                                hosted.process();
                            });
                        }, 2000);
                    },
                    onTransactionSuccess: function (approvalData) {
                        console.log(approvalData);
                        if (approvalData.resultStatus == "true") {
                            self.data.uniqueTransId =
                                approvalData.uniqueTransId;
                            self.data.accountCardType =
                                approvalData.accountCardType;
                            self.data.accountExpiryDate =
                                approvalData.accountExpiryDate;
                            self.data.last4digit = approvalData.maskedAccount;
                            self.data.externalTransactionId =
                                approvalData.externalTransactionId;
                            self.data.gravity_button = width;

                            self.verifyGravityTransaction();
                        } else {
                            self.callGravityIFrame(width);
                            self._message(
                                "Transaction failed. " +
                                    approvalData.resultMessage +
                                    ". Please try again.",
                                "danger"
                            );
                        }
                    },
                    onTransactionFailure: function (failureData) {
                        self.callGravityIFrame(width);
                        self._message(
                            "Transaction failed. " +
                                failureData.resultMessage +
                                ". Please try again.",
                            "danger"
                        );
                    }
                });

                self.loading = false;

                setTimeout(() => {
                    self.data.giframe_load = true;

                    $("#save-btn").on("click", function (event) {
                        self.loading = true;
                        event.preventDefault();
                        hosted.process();
                    });
                }, 2000);
            });
        },
        getToken() {
            let self = this;
            var client_id = self.data.client.id;
            var trans_type = "2"; // -- gravity save card

            return new Promise(function (resolve, reject) {
                self.$http
                    .post(process.env.BARRAMUNDI + "payment/generate-token", {
                        client_id: client_id,
                        trans_type: trans_type
                    })
                    .then(function (response) {
                        if (response.data.response.token) {
                            resolve(response.data.response.token);
                        } else {
                            self._message(
                                "Error initializing payment",
                                "danger"
                            );
                        }
                    });
            });
        },
        verifyGravityTransaction() {
            let self = this;
            var gravityData = {
                uniqueTransId: self.data.uniqueTransId,
                externalTransactionId: self.data.externalTransactionId
            };

            self.$http
                .post(process.env.BARRAMUNDI + "payment/verify-transaction", {
                    gravityData: gravityData
                })
                .then(function (response) {
                    if (response.data.response.success) {
                        self.save();
                    } else {
                        self._message(
                            "Payment failed. Please try again.",
                            "danger"
                        );
                        self.callGravityIFrame(self.data.gravity_button);
                    }
                });
        }
    }
};
</script>
<style>
#name_on_card {
    margin-left: 5px;
}

#is_primary {
    margin-left: 5px;
}

iframe#tokenframe_p {
    width: 102%;
    height: 109px;
    margin-top: -8px;
    margin-left: -0.25rem;
}

.giframe_labelp {
    width: 25%;
    height: 115px;
    float: left;
}

label#gcard_number {
    margin-top: 5px;
}

label#gexpiration {
    margin-top: 8px;
}

label#gscode {
    margin-top: 10px;
}

.iframe_p {
    width: 25%;
    height: 100px;
    float: left;
}

.iframe_label_p label#card_number {
    margin-top: 5px;
}

.iframe_label_p label#expiration {
    margin-top: 12px;
}

.iframe_label_p label#scode {
    margin-top: 8px;
    margin-right: 0px;
    display: inline-block;
}

.cus-information {
    margin-right: 0px;
}

#tip {
    margin-left: -5px;
    margin-right: -6px;
}

.iframe_content {
    width: 75%;
    float: right;
}

@media only screen and (max-width: 300) {
    .iframe_label_p label#scode {
        display: unset;
    }
}
</style>
